<!-- 业绩路演 -->
<template>
	<div v-if="quarterInfo.roadshowId" class="data-wrapper roadshow-data">
		<div class="roadshow-header">
			<p class="wrapper-title">{{ $t('enterprise.earnings-calls') }}</p>
		</div>
		<div class="roadshow-content" @click="gotoRoadshow()">
			<div class="roadshow-left">
				<p class="roadshow-title">{{ quarterInfo.roadshowTitle }}</p>
				<div class="roadshow-status-time">
					<span class="roadshow-status" :class="[`roadshow-status-${quarterInfo.roadshowStatus}`]">{{
						filterRoadshowStatus(quarterInfo.roadshowStatus)
					}}</span>
					<span class="roadshow-time">{{ quarterInfo.roadshowStartTime | dateFormatYearMonthDateTime }}</span>
				</div>
			</div>
			<div v-if="quarterInfo.roadshowCover" class="roadshow-right">
				<img class="roadshow-img" :src="quarterInfo.roadshowCover" alt="" />
			</div>
		</div>
	</div>
</template>

<script setup>
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

const ROADSHOW_STATUS = {
	1: '筹备中',
	2: '待审批',
	3: '审批不通过',
	4: '审批通过',
	5: '待开始',
	6: '进行中',
	7: '已结束',
	8: '可回放',
	9: '无人上麦',
	10: '无人入会',
	11: '已过期',
	12: '已删除',
	13: '已取消',
	14: '错误状态'
};

const props = defineProps({
	quarterInfo: {
		type: Object,
		default: () => ({})
	}
});

const { viewModule } = useModuleNavigation();
const gotoRoadshow = () => {
	viewModule('quarterly_performance_roadshow', props.quarterInfo);
};

const filterRoadshowStatus = status => {
	return ROADSHOW_STATUS[status];
};
</script>

<style lang="less" scoped>
@import '@/style/mixin/mixins';
@import '@/style/mixin/text-overflow';

.data-wrapper {
	margin-bottom: 0.14rem;
	padding: 0.14rem 0.12rem;
	border-radius: 0.06rem;
	background: #fff;
	overflow: hidden;

	.wrapper-title {
		color: #333;
		font-family: 'PingFang SC';
		font-size: 0.16rem;
		font-style: normal;
		font-weight: 500;
		line-height: 0.22rem;
	}
}

.roadshow-data {
	.roadshow-content {
		margin-top: 0.14rem;
		display: flex;
	}
	.roadshow-left {
		flex: 1;
	}
	.roadshow-right {
		margin-left: 0.08rem;
		width: 0.8rem;
		height: 0.6rem;
	}
	.roadshow-title {
		color: #333;
		font-family: 'PingFang SC';
		font-size: 0.15rem;
		font-style: normal;
		font-weight: 500;
		line-height: 0.21rem;
		.text-overflow-multi-row(2);
	}
	.roadshow-status-time {
		margin-top: 0.08rem;
		display: flex;
		align-items: center;
	}
	.roadshow-status {
		height: 0.16rem;
		padding: 0 0.06rem;
		border-radius: 1px;
		color: #fff;
		font-family: 'PingFang SC';
		font-size: 0.1rem;
		font-style: normal;
		font-weight: 400;
		line-height: 0.16rem;

		&-1,
		&-2,
		&-5 {
			background: #f26a3d;
		}
		&-3,
		&-12,
		&-13,
		&-14 {
			background: #f23d3d;
		}
		&-4,
		&-8 {
			background: #36d95f;
		}
		&-6 {
			background: #3964e5;
		}
		&-7,
		&-9,
		&-10,
		&-11 {
			background: #c9cdd4;
		}
	}
	.roadshow-time {
		margin-left: 0.08rem;
		color: #616163;
		font-family: 'PingFang SC';
		font-size: 0.12rem;
		font-style: normal;
		font-weight: 400;
		line-height: 0.16rem;
	}
	.roadshow-img {
		max-width: 100%;
	}
}
</style>
